import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import scrollToTop from "../components/scroll-to-top";

const ServiceNav = () => {
  const location = useLocation(); // Hook to get the current location
  const [activePage, setActivePage] = useState(location.pathname);

  useEffect(() => {
    setActivePage(location.pathname); // Update the active page when the location changes
  }, [location]);
  return (
    <>
      <div className="services-nav">
        <div className="link-container">
          <Link
            to="/design"
            className={`service-nav-link ${
              activePage === "/design" ? "service-active" : ""
            }`}
            onClick={() => {
              scrollToTop();
            }}
          >
            Web Design <span>Services</span>
          </Link>
          <hr />
          <Link
            to="/development"
            className={`service-nav-link ${
              activePage === "/development" ? "service-active" : ""
            }`}
            onClick={() => {
              scrollToTop();
            }}
          >
            Web Development <span>Services</span>
          </Link>{" "}
          <hr />
          <Link
            to="/hosting-maintenance"
            className={`service-nav-link ${
              activePage === "/hosting-maintenance" ? "service-active" : ""
            }`}
            onClick={() => {
              scrollToTop();
            }}
          >
            Hosting & Maintenance <span>Services</span>
          </Link>{" "}
          <hr />
          <Link
            to="/consulting"
            className={`service-nav-link ${
              activePage === "/consulting" ? "service-active" : ""
            }`}
            onClick={() => {
              scrollToTop();
            }}
          >
            Web Consulting <span>Services</span>
          </Link>{" "}
          <hr />
          <Link
            to="/landing-more"
            className={`service-nav-link ${
              activePage === "/landing-more" ? "service-active" : ""
            }`}
            onClick={() => {
              scrollToTop();
            }}
          >
            <span>Landing Pages & </span>More
          </Link>
        </div>
      </div>
    </>
  );
};

export default ServiceNav;
